// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { OrderStateContext } from "@insite/client-framework/Store/Data/Orders/OrdersSelectors";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import OrderLinesList, { OrderLinesListStyles } from "@insite/content-library/Components/OrderLinesList";
import React, { FC, useContext } from "react";

type Props = WidgetProps;

export interface RequestRmaConfirmationProductList {
    orderLines?: OrderLinesListStyles;
}

export const requestRmaConfirmationProductList: RequestRmaConfirmationProductList = {};

const styles = requestRmaConfirmationProductList;

const RequestRmaConfirmationProductList: FC<Props> = () => {
    const { value: order } = useContext(OrderStateContext);

    if (!order || !order.orderLines) {
        return null;
    }

    return <OrderLinesList order={order} extendedStyles={styles.orderLines} />;
};

const widgetModule: WidgetModule = {
    component: RequestRmaConfirmationProductList,
    definition: {
        allowedContexts: ["RequestRmaSuccessPage"],
        group: "Request Rma Confirmation" as any,
    },
};

export default widgetModule;
